import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import { ColumnDefinitionV3, TableV3Component } from '@gea/digital-ui-lib';

@Component({
  selector: 'formly-geaui-table-v3',
  imports: [ReactiveFormsModule, FormlyModule, TableV3Component],
  template: `
    <div class="table-container">
      <geaui-table-v3
        [tableId]="tableId"
        [selectionMode]="'single'"
        [columnDefinitions]="columnDefinitions"
        [data]="data"
        (selectionChange)="handleSelectionChange($event)"></geaui-table-v3>
    </div>
  `,
  styles: `
    .table-container {
      background-color: white;
      padding: 1.5rem;
      border: 0.125rem solid var(--geaui-grey-03);
      border-radius: 0.5rem;
      box-sizing: border-box;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeaUiTableV3TypeComponent extends FieldType<FieldTypeConfig> implements OnInit {
  tableId = '';

  ngOnInit(): void {
    const key = this.field.key?.toString().trim();
    if (!key) {
      throw new Error('Formly table fields require a unique key.');
    }

    this.tableId = key;
  }

  get formGroup(): FormGroup {
    return this.form as FormGroup;
  }

  get data(): unknown[] {
    return Array.isArray(this.formControl.value) ? this.formControl.value : [];
  }

  get columnDefinitions(): ColumnDefinitionV3[] {
    const checkmarkColumnDefinition: ColumnDefinitionV3 = {
      displayName: '',
      key: 'checkmark',
      width: 44,
      sortable: false,
      resizeable: false,
      visible: true,
    };

    const columns = (this.props['columns'] as ColumnDefinitionV3[] | undefined) ?? [];
    return [checkmarkColumnDefinition, ...columns];
  }

  handleSelectionChange(selection: any): void {
    console.log('New selection: ', selection);
  }

  override defaultOptions = {
    className: 'fullWidthComponent',
  };
}
